/**
 * Utility functions for preventing background scrolling when modals are open
 */

let scrollLockCount = 0;
let originalBodyStyle = '';

export const lockBodyScroll = (): void => {
  scrollLockCount++;
  
  if (scrollLockCount === 1) {
    // Store original body styles
    originalBodyStyle = document.body.style.cssText;
    
    // Add CSS class for additional scroll prevention
    document.body.classList.add('modal-open');
    
    // Apply scroll lock styles
    document.body.style.cssText = `
      ${originalBodyStyle}
      overflow: hidden !important;
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      width: 100% !important;
      height: 100% !important;
    `;
  }
};

export const unlockBodyScroll = (): void => {
  scrollLockCount = Math.max(0, scrollLockCount - 1);
  
  if (scrollLockCount === 0) {
    // Remove CSS class
    document.body.classList.remove('modal-open');
    
    // Restore original body styles
    document.body.style.cssText = originalBodyStyle;
  }
};

export const isScrollLocked = (): boolean => {
  return scrollLockCount > 0;
};
